import {useCallback, useMemo} from "react";


export default function useTableSeekerSearch() {


	const handleSearch = useCallback((searchQuery, currentRow, columns, isCaseSensitive) => {
		let found = false
		columns.every(({ searchable }, idx) => {
			if (!searchable) return true

			const value = currentRow[idx]
			if (!value) return true

			try {
				let normValue = value.toString()
				let normSQ = searchQuery || ''
				if (!isCaseSensitive) {
					normValue = normValue.toLowerCase()
					normSQ = normSQ.toLowerCase()
				}
				found = normValue.indexOf(normSQ) > -1
			} catch { return true }

			return !found;
		})
		return found
	}, [])

	return {
		handleSearch
	}
}
